import { find } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Steps, Tooltip } from 'tdesign-react';
import { AssignmentCheckedIcon } from 'tdesign-icons-react';
import { getTaskOptions } from '@/pages/Maintenance/Template/Flow/Detail/NodeList';

const { StepItem } = Steps;

function FlowSteps({ steps }) {
  const getLabel = (item) => {
    const { stencilType, task, choiceType } = item;
    const options = getTaskOptions(stencilType);

    return (
      <>
        {choiceType === 2 && (
          <Tooltip content='自动选择'>
            <AssignmentCheckedIcon
              style={{ fontSize: 15, marginTop: -2, marginRight: 4, color: 'green' }}
            />
          </Tooltip>
        )}
        {find(options, { value: task })?.label}
      </>
    );
  };

  return (
    <Root>
      <Title>执行步骤</Title>
      <Steps current={null} layout='vertical'>
        {steps.map((item, index) => (
          <StepItem
            value={item.stepId}
            key={`${item.stepId}/${index}`}
            title={item.prettyText}
            content={getLabel(item)}
          />
        ))}
      </Steps>
    </Root>
  );
}

export default connect((state) => ({
  steps: state.execFlow.steps,
}))(FlowSteps);

const Root = styled.div`
  padding: 16px 10px 0 20px;
  width: 240px;
  box-sizing: border-box;
  .t-steps {
    .t-steps-item__icon {
      margin-right: 4px;
      .t-steps-item__icon--number {
        border-color: transparent;
        background-color: transparent;
      }
    }
    .t-steps-item--clickable {
      cursor: default;
    }
    .t-steps-item__icon--number {
      font-size: 13px;
      color: var(--td-text-color-primary);
    }
    .t-steps-item__title {
      font-size: 13px;
      color: var(--td-text-color-primary);
      font-weight: normal;
      margin-bottom: 0;
    }
    .t-steps-item__description {
      font-size: 12px;
    }
  }
`;

const Title = styled.div`
  color: var(--td-text-color-primary);
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 12px;
`;
